import React, { useState } from 'react';
import { useCookies } from 'react-cookie';

import { Star } from '../icons';

let cookieKey = 'cnp-location';

export const Location = ({ location }: { location: any }) => {
	const [cookies, setCookie, removeCookie] = useCookies([cookieKey]);
	const currentDate = new Date();
	const nextYear = new Date();

	nextYear.setFullYear(currentDate.getFullYear() + 1);

	return (
		<div className='loc-info'>
			{location['featured_media_url'] && (
				<div>
					<img src={location['featured_media_url']} />
				</div>
			)}
			<div className='loc-details'>
				<div className='loc-header'>
					<h4>{location['title']['rendered']}</h4>
					<div className='wp-block-buttons'>
						<button
							className='wp-block-button is-style-favorite'
							onClick={() => {
								setCookie(cookieKey, location['id'], {
									expires: nextYear,
									path: '/'
								});
								//@ts-ignore
								updateSavedLocation();
							}}
						>
							{
								<Star
									active={
										cookies[cookieKey] && cookies[cookieKey] == location['id']
									}
								/>
							}{' '}
							{`${
								cookies[cookieKey] && cookies[cookieKey] == location['id']
									? ''
									: 'MAKE'
							} MY LOCATION`}
						</button>
					</div>
				</div>
				{location['meta']['location_business_hours'] && (
					<p
						dangerouslySetInnerHTML={{
							__html: location['meta']['location_business_hours'],
						}}
					>
						{/* <span>We’re open today!</span> */}
					</p>
				)}
				{location['meta']['location_phone_number'] && (
					<a href={`tel:${location['meta']['location_phone_number']}`}>
						{location['meta']['location_phone_number']}
					</a>
				)}
				{location['meta']['location_address'] && (
					<a
						href={`https://maps.apple.com/?q=${location['meta']['location_address']}`}
					>
						{location['meta']['location_address']}
					</a>
				)}
				{location['link'] &&
					location['meta']['location_detail_visibility'] != 'hidden' && (
						<div className='wp-block-buttons'>
							<a
								className='wp-block-button is-style-white-chevron'
								href={location['link']}
							>
								Full Location Details
							</a>
						</div>
					)}
			</div>
		</div>
	);
};
